import SamplePage from "../Pages/SamplePage/SamplePage";

import DashboardPage from "../Pages/Dashboard/Dashboard";

import MyProfilePage from "../Pages/MyProfile/MyProfile";


// import MyIdCardPage from "../Pages/MyIdCard/MyIdCard";

import AccountSettingPage  from  "../Pages/AccountSettings/AccountSettings";
 import ActivateBotPage from "../Pages/ActivateBot/ActivateBot";
 import BonanzaPage from "../Pages/Reward/Bonanza";
 import LifeTimeRewardPage from "../Pages/Reward/LifeTimeReward";

//  import USSDTTRC20Page from "../Pages/DepositFund/USDTTRC20";
//  import USSDTBEP20Page from "../Pages/DepositFund/USDTBEP20";

 import FundINRPage from "../Pages/DepositFund/FundINR";
 import FxstTokenHistoryPage  from "../Pages/DepositFund/FXSTTokenHistory";
 import DepositHistoryPage  from "../Pages/DepositFund/DepositHistory";
 import DepositWalletPage  from "../Pages/WalletTransfer/DepositWallet";
 import FxstPayWalletPage  from "../Pages/WalletTransfer/FxstPayWallet";
 import FxstockWalletPage  from "../Pages/WalletTransfer/FxstockWallet";
 import FxWalletReport from '../Pages/WalletTransfer/FxWalletReport'

import RequestWithdrawPage  from "../Pages/Withdraw/RequestWithdraw";
import WithdrawHistoryPage  from "../Pages/Withdraw/WithdrawHistory";

import LevelwiseTeamList from '../Pages/TeamOverviews/LevelwiseTeamList'
import BusinessReport from '../Pages/TeamOverviews/BusinessReport'
import GenerationTree from '../Pages/TeamOverviews/GenerationTree'
import DepositFXSTToken from '../Pages/DepositFund/DepositFXSTToken'
import SupportTicket from '../Pages/SupportTicket/SupportTicket'
import MyDirectPage from '../Pages/TeamOverviews/MyDirectReport'
import MyTeamBusinessPage from '../Pages/TeamOverviews/MyTeamBusiness'
import TeamDownline from '../Pages/TeamOverviews/Downline'
import FundReportINR from '../Pages/DepositFund/RequestfundINR'
import P2PTransferPage from "../Pages/WalletTransfer/P2PTransfer";
import P2PWalletReport from "../Pages/WalletTransfer/P2PReport";
import Activation from "../Pages/Activation/Activation";
import ActivationReport from "../Pages/Activation/ActivationReport";
import BulkActivationPage from "../Pages/Activation/BulkActivationPage";

import TransectionlogPage from "../Pages/Incomes/TransectionlogPage";
import NewsandEvents from "../Pages/NewsANDEvents/NewsandEvents";
import WithdrawReportPage from "../Pages/Withdraw/WithdrawReportPage";
import LevelIncome from "../Pages/Incomes/LevelIncome";
import RewardStatus from "../Pages/Incomes/RewardStatus";
import RewardIncome from "../Pages/Incomes/RewardIncome";
import TotalEarning from "../Pages/Incomes/TotalEarning";
import SearchPinPage from "../Pages/EPin/SearchPin";
import SendMultiplePinPage from "../Pages/EPin/SendMultiplePin";
import TransferEPinPage from "../Pages/EPin/TransferEpin";
import Registration from "../Pages/Registration/Registration";
import ThankYouRegister from "../Pages/ThankYouRegister/ThankYouRegister";
import UpgradeMember from "../Pages/UpgradeMember/UpgradeMember";
import UpgradeSuccess from "../Pages/UpgradeSuccess/UpgradeSuccess";
// import { Component } from "react";
import PinTransferSuccesspage from "../Pages/EPin/PinTransferSuccess";
import TransferEpin from "../Component/EPin/TransferEpin";
import PinOrderReport from "../Component/EPin/PinOrderReport";
import WelcomeLetterPage from "../Pages/WelcomeLetterPage/WelcomeLetterPage";
import BlankPageMain from "../Pages/TeamOverviews/BlankPage";
//import { WithdrawHistory } from "../utils/Constant";


const routes = [

  // Sample Page
  { path: `${import.meta.env.BASE_URL}/samplepage`, Component: <SamplePage />},
  // Dashboard Page
  { path: `${import.meta.env.BASE_URL}/dashboard`, Component: <DashboardPage /> },

  { path: `${import.meta.env.BASE_URL}/myprofile`, Component: <MyProfilePage />},

   { path: `${import.meta.env.BASE_URL}/welcomeletter`, Component: <WelcomeLetterPage />},

  // { path: `${import.meta.env.BASE_URL}/myidcard`, Component: <MyIdCardPage />},
  { path: `${import.meta.env.BASE_URL}/accountsettings`, Component: <AccountSettingPage />},
  { path: `${import.meta.env.BASE_URL}/activatebot`, Component: <ActivateBotPage />},
  { path: `${import.meta.env.BASE_URL}/topupblukactivation`, Component: <BulkActivationPage />},
  { path: `${import.meta.env.BASE_URL}/bonanza`, Component: <BonanzaPage />},
  { path: `${import.meta.env.BASE_URL}/LifeTimeReward`, Component: <LifeTimeRewardPage />},
  // { path: `${import.meta.env.BASE_URL}/trc20`, Component: <USSDTTRC20Page />},
  // { path: `${import.meta.env.BASE_URL}/bep20`, Component: <USSDTBEP20Page />},
  { path: `${import.meta.env.BASE_URL}/requestfund`, Component: <FundINRPage />},
  { path: `${import.meta.env.BASE_URL}/FxstTokenHistory`, Component: <FxstTokenHistoryPage />},
  { path: `${import.meta.env.BASE_URL}/DepositHistory`, Component: <DepositHistoryPage />},
  { path: `${import.meta.env.BASE_URL}/inrfundreport`, Component: <FundReportINR/>},


  { path: `${import.meta.env.BASE_URL}/DepositWallet`, Component: <DepositWalletPage />},
  { path: `${import.meta.env.BASE_URL}/FxstPayWallet`, Component: <FxstPayWalletPage />},
  { path: `${import.meta.env.BASE_URL}/p2ptransfer`, Component: <P2PTransferPage />},
  { path: `${import.meta.env.BASE_URL}/FxstockWallet`, Component: <FxstockWalletPage />},
  { path: `${import.meta.env.BASE_URL}/fxstockwalletreport`, Component: <FxWalletReport />},
  { path: `${import.meta.env.BASE_URL}/p2pwalletreport`, Component: <P2PWalletReport/>},
  { path: `${import.meta.env.BASE_URL}/registerxyz`, Component: <Registration/>},
  { path: `${import.meta.env.BASE_URL}/thankyouregister`, Component: <ThankYouRegister/>},
  { path: `${import.meta.env.BASE_URL}/upgradeMember`, Component: <UpgradeMember/>},
  { path: `${import.meta.env.BASE_URL}/upgradeSuccess`, Component: <UpgradeSuccess/>},
  { path: `${import.meta.env.BASE_URL}/pinOrderReport`, Component: <PinOrderReport/>},



  { path: `${import.meta.env.BASE_URL}/supportticket`, Component: <SupportTicket/>},
  
  { path: `${import.meta.env.BASE_URL}/levelwiseteamlist`, Component: <LevelwiseTeamList/>},
  { path: `${import.meta.env.BASE_URL}/businessreport`, Component: <BusinessReport/>},
  { path: `${import.meta.env.BASE_URL}/teamdownline`, Component: <TeamDownline/>},
  { path: `${import.meta.env.BASE_URL}/tree`, Component: <GenerationTree/>},
  { path: `${import.meta.env.BASE_URL}/sponsorlist`, Component: <MyDirectPage/>},
  { path: `${import.meta.env.BASE_URL}/myteambusiness`, Component: <MyTeamBusinessPage/>},
  { path: `${import.meta.env.BASE_URL}/fxstdeposit`, Component: <DepositFXSTToken/>},
  { path: `${import.meta.env.BASE_URL}/activation`, Component: <Activation/>},
  { path: `${import.meta.env.BASE_URL}/activationReport`, Component: <ActivationReport/>},
  
  { path: `${import.meta.env.BASE_URL}/LevelIncome`, Component: <LevelIncome/>},
  {path:`${import.meta.env.BASE_URL}/RewardStatus`, Component:<RewardStatus/>},
  {path:`${import.meta.env.BASE_URL}/RewardIncome`, Component:<RewardIncome/>},
    {path:`${import.meta.env.BASE_URL}/TotalEarning`, Component:<TotalEarning/>},
  { path: `${import.meta.env.BASE_URL}/searchpin`, Component: <SearchPinPage/>},
  { path: `${import.meta.env.BASE_URL}/SendMultiplePin`, Component: <SendMultiplePinPage />},
  { path: `${import.meta.env.BASE_URL}/transferepin`, Component: <TransferEPinPage />},
  { path: `${import.meta.env.BASE_URL}/transferepinForm`, Component: <TransferEpin/>},

  
  { path: `${import.meta.env.BASE_URL}/transectionlogs`, Component: <TransectionlogPage/>},
  { path: `${import.meta.env.BASE_URL}/newsandevents`, Component: <NewsandEvents/>},
  
   // Withdraw routes here 
  { path: `${import.meta.env.BASE_URL}/RequestWithdraw`, Component: <RequestWithdrawPage />},
  { path: `${import.meta.env.BASE_URL}/WithdrawHistory`, Component: <WithdrawHistoryPage />},
  { path: `${import.meta.env.BASE_URL}/WithdrawReportPage`, Component: <WithdrawReportPage />},
  {path: `${import.meta.env.BASE_URL}/PinTransferSuccesspage`,Component:<PinTransferSuccesspage />},
  {path: `${import.meta.env.BASE_URL}/blankpage`,Component: <BlankPageMain/>},

]

export default routes;